<div class="otp-page">
  <mat-card class="otp-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Request OTP</mat-card-title>
      <mat-card-subtitle>Send a one-time code to your registered email</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <button mat-flat-button type="button" color="primary" class="submit-btn" (click)="onRequestOtp()" [disabled]="isSubmitting()">
        @if (isSubmitting()) { Sending... } @else { Send OTP Code }
      </button>

      @if (errorMessage()) {
      <div class="error-message">{{ errorMessage() }}</div>
      }
      @if (successMessage()) {
      <div class="success-message">{{ successMessage() }}</div>
      }

      <div class="links">
        <a class="back-link" routerLink="/verify">Go to Verify</a>
        <a class="back-link" routerLink="/login">Back to Login</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>
